import axios from 'axios';
import { debug } from 'debug';
import { getReasonPhrase, StatusCodes } from 'http-status-codes';
import { HTTPRequestError, WrappedResponse } from '../../models/http';
import { OPERATION_ROUTE } from '../configs/operation-api';
import {
	SocialClaimRequestInterface,
	SocialClaimResponseInterface,
} from '../models/operation-claim';

export const claim = async (
	payload: SocialClaimRequestInterface,
): Promise<SocialClaimResponseInterface> => {
	const response = await axios.post<
		WrappedResponse<SocialClaimResponseInterface>
	>(OPERATION_ROUTE.CLAIM_POST, payload);

	if (response.status !== StatusCodes.OK) {
		debug(`Error: ${response.status}`);
		throw new HTTPRequestError(getReasonPhrase(response.status));
	}

	return response.data.responsePayload;
};
